(function() {
  'use strict';

  /* ============================================= */
  /*  SERVICIOS DE MAPA (100% gratuitos, sin API key) */
  /* ============================================= */

  // Basemap vectorial de OpenFreeMap: gratis, sin token y sin limite de uso.
  // "positron" es el estilo gris claro, el equivalente a mapbox light.
  var BASEMAP_STYLE = 'https://tiles.openfreemap.org/styles/positron';

  // Geocodificador: Photon (OpenStreetMap) como principal y Nominatim de
  // respaldo. Ninguno cobra ni pide key. Photon esta pensado para autocompletar.
  var GEO_BIAS_LAT = -33.45;
  var GEO_BIAS_LON = -70.65;
  var GEO_BBOX = '-75.8,-56.0,-66.0,-17.5'; // Chile continental

  function escapeHtml(str) {
    var d = document.createElement('div');
    d.textContent = str;
    return d.innerHTML;
  }

  // Numero de casa que escribio el usuario. Se busca al final del primer tramo
  // (antes de la primera coma) porque en Chile el numero va despues de la calle:
  // "Gluck 3271" -> 3271, "1 Norte 1234" -> 1234, pero "1 Norte" -> sin numero.
  function numeroPedido(consulta) {
    var calle = (consulta || '').split(',')[0].trim();
    var m = calle.match(/(\d{1,6})\s*$/);
    return m ? m[1] : '';
  }

  // Pega el numero pedido a la via, salvo que la via ya termine en ese numero
  // (calles tipo "Avenida 1" no deben quedar como "Avenida 1 1").
  function conNumero(via, numero) {
    if (!via) return '';
    if (!numero) return via;
    if (new RegExp('(^|\\s)' + numero + '\\s*$').test(via)) return via;
    return via + ' ' + numero;
  }

  // Arma la direccion legible desde las propiedades de Photon, imitando el
  // "full_address" que devolvia Mapbox: calle + numero, comuna, region.
  // Cuando el usuario escribio un numero se muestra ESE, nunca el que traiga
  // OpenStreetMap: en varias calles OSM no tiene la numeracion completa y
  // devuelve otra casa de la misma cuadra, lo que confundia al cliente.
  function photonLabel(p, numero) {
    var partes = [];
    var via = p.street || p.name || '';
    var hn = numero || p.housenumber || '';
    var principal = conNumero(via, hn);
    if (principal) partes.push(principal);
    if (p.district && p.district !== p.city) partes.push(p.district);
    if (p.city && p.city !== via) partes.push(p.city);
    if (p.state) partes.push(p.state);
    return partes.join(', ');
  }

  // Etiqueta compacta para Nominatim, que devuelve un display_name larguisimo
  // y a veces con el numero como primer elemento.
  function nominatimLabel(x, numero) {
    var partes = (x.display_name || '').split(',').map(function(s) { return s.trim(); });
    if (partes.length && /^\d+$/.test(partes[0])) partes.shift();
    var via = partes.shift() || '';
    if (!via) return '';
    return [conNumero(via, numero)].concat(partes.slice(0, 2)).join(', ');
  }

  // Colapsa duplicados (una misma calle puede volver 3 veces con numeros
  // distintos). De cada grupo se queda el punto cuyo numero esta mas cerca del
  // pedido, que es lo mas parecido a interpolar sobre la cuadra.
  function dedupe(items) {
    var porEtiqueta = {};
    var orden = [];
    items.forEach(function(it) {
      if (!it.label) return;
      if (!porEtiqueta[it.label]) orden.push(it.label);
      var previo = porEtiqueta[it.label];
      if (!previo || it.dist < previo.dist) porEtiqueta[it.label] = it;
    });
    return orden.map(function(k) {
      return { label: porEtiqueta[k].label, lat: porEtiqueta[k].lat, lng: porEtiqueta[k].lng };
    });
  }

  // Devuelve [{ label, lat, lng }]. Si Photon falla o no trae nada, reintenta
  // con Nominatim para no dejar el buscador muerto.
  async function geocode(consulta, limite) {
    var numero = numeroPedido(consulta);
    var pedido = parseInt(numero, 10);
    var q = consulta + ', Chile';
    // Se piden mas resultados de los que se muestran porque el dedupe colapsa
    // las repeticiones de una misma calle.
    var crudos = Math.min(limite + 5, 12);

    function distancia(hnTexto) {
      var hn = parseInt(hnTexto, 10);
      return (!isNaN(pedido) && !isNaN(hn)) ? Math.abs(hn - pedido) : Infinity;
    }

    try {
      var url = 'https://photon.komoot.io/api/?q=' + encodeURIComponent(q)
        + '&limit=' + crudos
        + '&lat=' + GEO_BIAS_LAT + '&lon=' + GEO_BIAS_LON
        + '&bbox=' + GEO_BBOX;
      var resp = await fetch(url);
      if (resp.ok) {
        var data = await resp.json();
        var salida = dedupe((data.features || []).map(function(f) {
          var p = f.properties || {};
          return {
            label: photonLabel(p, numero),
            lat: f.geometry.coordinates[1],
            lng: f.geometry.coordinates[0],
            dist: distancia(p.housenumber)
          };
        }));
        if (salida.length) return salida.slice(0, limite);
      }
    } catch (e) { /* cae al respaldo */ }

    try {
      var url2 = 'https://nominatim.openstreetmap.org/search?format=jsonv2'
        + '&countrycodes=cl&accept-language=es&limit=' + crudos
        + '&q=' + encodeURIComponent(q);
      var resp2 = await fetch(url2);
      if (resp2.ok) {
        var data2 = await resp2.json();
        return dedupe((data2 || []).map(function(x) {
          return {
            label: nominatimLabel(x, numero),
            lat: parseFloat(x.lat),
            lng: parseFloat(x.lon),
            dist: Infinity
          };
        })).slice(0, limite);
      }
    } catch (e) { /* sin resultados */ }

    return [];
  }

  /* ============================================= */
  /*  ZONE DATA                                    */
  /* ============================================= */

  var COVERAGE_ZONES = {
    santiago: {
      center: [-70.65, -33.45],
      zoom: 10,
      zones: [
        {
          id: 'diario', name: 'Reparto Diario (Norte + Sur)', shortName: 'Reparto Diario', subtitle: '(Norte + Sur)', price: '$3.990',
          schedule: 'Lunes, miércoles, viernes y sábado', badges: [],
          emoji: '\u{1F7E0}', color: 'diario',
          comunas: [],
          geoNames: ['Reparto Diario'],
          is_nextday: true,
          nextday_message: '\u{1F4E6} Compra hoy hasta las 18:00 hrs y te llega mañana (días indicados).'
        },
        {
          id: 'martes', name: 'Martes (Norte Completo)', price: '$4.990',
          schedule: 'Martes — zona centro hacia el norte', badges: [],
          emoji: '\u{1F535}', color: 'martes',
          comunas: [],
          geoNames: ['Martes Norte']
        },
        {
          id: 'jueves', name: 'Jueves (Sur Completo)', price: '$4.990',
          schedule: 'Jueves — zona centro hacia el sur', badges: [],
          emoji: '\u{1F7E2}', color: 'jueves',
          comunas: [],
          geoNames: ['Jueves Sur']
        }
      ]
    },
    quinta_region: {
      center: [-71.55, -33.02],
      zoom: 12,
      zones: [
        {
          id: 'v-vina', name: 'Viña, Reñaca, Concón y Valparaíso', price: '$3.490',
          type: 'DELIVERY NEXTDAY',
          schedule: '¡Te llega mañana! · Lunes a Sábado',
          windows: {
            am: '10:00 - 13:00', am_days: 'Lun a Sáb',
            pm: '16:00 - 18:00', pm_days: 'Lun a Vie',
            note: 'Elige tu bloque horario en la pasarela de pago'
          },
          // Cada comuna lleva el color del polígono que le corresponde en el mapa.
          comunas: [
            { name: 'Viña del Mar', color: '#673AB7' },
            { name: 'Reñaca', color: '#E65100' },
            { name: 'Concón', color: '#E65100' },
            { name: 'Valparaíso', color: '#F48FB1' }
          ],
          color: 'express',
          geoNames: ['Viña Centro y Alrededores $2.990', 'Valparaio-Nva Aurora $3.990', 'Concon- Reñaca $3.990']
        },
        {
          id: 'v-quilpue', name: 'Quilpué, Villa Alemana y Peñablanca', price: '$3.490',
          type: 'Delivery Semanal',
          schedule: '1 vez por semana · Viernes o Sábado (se confirma la fecha el día anterior)',
          comunas: [
            { name: 'Quilpué', color: '#01579B' },
            { name: 'Villa Alemana', color: '#01579B' },
            { name: 'Peñablanca', color: '#01579B' }
          ],
          color: 'semanal',
          geoNames: ['Quilpue,VA, Peñablanca $3.500']
        },
        {
          id: 'v-curauma', name: 'Curauma y Placilla', price: '$3.490',
          type: 'Delivery Semanal',
          schedule: '1 VEZ POR SEMANA, SE CONFIRMA LA FECHA EL DÍA ANTERIOR',
          comunas: [
            { name: 'Curauma', color: '#00796B' },
            { name: 'Placilla', color: '#00796B' }
          ],
          color: 'semanal',
          geoNames: ['Placilla y Curauma $3.500']
        }
      ]
    }
  };

  /* ---- GeoJSON name → site color (from CSS card ::before) ---- */

  var ZONE_FILL_COLORS = {
    'Reparto Diario': '#FFB300',
    'Martes Norte': '#6565F5',
    'Jueves Sur': '#4CAF50',
    'Viña Centro y Alrededores $2.990': '#673AB7',
    'Valparaio-Nva Aurora $3.990': '#F48FB1',
    'Concon- Reñaca $3.990': '#E65100',
    'Quilpue,VA, Peñablanca $3.500': '#01579B',
    'Placilla y Curauma $3.500': '#00796B'
  };

  /* ---- Build geoName → zone lookup ---- */

  var GEO_NAME_TO_ZONE = {};
  ['santiago', 'quinta_region'].forEach(function(regionKey) {
    COVERAGE_ZONES[regionKey].zones.forEach(function(z) {
      (z.geoNames || []).forEach(function(gn) {
        GEO_NAME_TO_ZONE[gn] = { zone: z, region: regionKey };
      });
    });
  });

  /* ---- Build Mapbox fill-color match expression ---- */

  var fillColorExpr = ['match', ['get', 'name']];
  Object.keys(ZONE_FILL_COLORS).forEach(function(name) {
    fillColorExpr.push(name, ZONE_FILL_COLORS[name]);
  });
  fillColorExpr.push('#cccccc');

  /* ============================================= */
  /*  ZONE FINDER (turf.js)                        */
  /* ============================================= */

  function findZone(lat, lng, geojson) {
    var pt = turf.point([lng, lat]);
    for (var i = 0; i < geojson.features.length; i++) {
      var feature = geojson.features[i];
      var name = feature.properties.name;
      if (GEO_NAME_TO_ZONE[name] && turf.booleanPointInPolygon(pt, feature)) {
        var match = GEO_NAME_TO_ZONE[name];
        var z = match.zone;
        return {
          id: z.id, name: z.name, price: z.price,
          schedule: z.schedule, badges: z.badges || [],
          type: z.type, comunas: z.comunas,
          region: match.region
        };
      }
    }
    return null;
  }

  /* ============================================= */
  /*  CARD HTML TEMPLATES                          */
  /* ============================================= */

  // Una comuna puede venir como string o como { name, color }: con color se le
  // pinta un punto del mismo tono que su polígono en el mapa.
  function comunaChips(list) {
    return (list || []).map(function(c) {
      if (typeof c === 'string') return '<span>' + escapeHtml(c) + '</span>';
      if (!c || !c.name) return '';
      if (!c.color) return '<span>' + escapeHtml(c.name) + '</span>';
      return '<span class="cov-comuna--dot" style="--cov-comuna-color:' + escapeHtml(c.color) + '">'
        + escapeHtml(c.name) + '</span>';
    }).join('');
  }

  function stgoCardHtml(z) {
    var comunas = comunaChips(z.comunas);
    var badges = (z.badges || []).map(function(b) { return '<span class="cov-badge-next-day">' + b + '</span>'; }).join('');
    var titleHtml = z.emoji + ' ' + z.name;
    if (z.subtitle) {
      titleHtml = z.emoji + ' ' + z.shortName + '<span class="cov-zone-sub">' + z.subtitle + '</span>';
    }
    var nextdayBadge = '';
    var html = '<div class="cov-zone-card cov-zone-' + z.color + '" data-zone="' + z.id + '">'
      + '<div class="cov-zone-header">'
      + '<span class="cov-zone-name">' + titleHtml + ' ' + nextdayBadge + '</span>'
      + '<span class="cov-zone-price">' + z.price + '</span>'
      + '</div>'
      + '<div class="cov-zone-days">\u{1F4C5} ' + z.schedule + ' ' + badges + '</div>';
    if (z.is_nextday && z.nextday_message) {
      html += '<div class="cov-zone-nextday-msg">' + z.nextday_message + '</div>';
    }
    html += '<div class="cov-zone-free">Gratis en pedidos sobre $79.990</div>';
    html += '<a href="#coverage-address-input" class="cov-verify-btn" onclick="(function(e){e.preventDefault();var el=document.getElementById(\'coverage-address-input\');if(el){el.scrollIntoView({behavior:\'smooth\',block:\'center\'});setTimeout(function(){el.focus();},400);}}).call(this,event)">Verifica tu cobertura →</a>';
    if (comunas) {
      html += '<div class="cov-zone-comunas">' + comunas + '</div>';
    }
    html += '</div>';
    return html;
  }

  // Una fila del widget de reparto: etiqueta AM/PM, horario y días en que aplica
  // (el sábado no tiene reparto PM, por eso cada bloque lleva sus propios días).
  function windowRow(tag, hours, days) {
    if (!hours) return '';
    return '<span class="cov-vr-window">'
      + '<b>' + tag + '</b>'
      + '<span class="cov-vr-window__hours">' + escapeHtml(hours) + '</span>'
      + (days ? '<span class="cov-vr-window__days">' + escapeHtml(days) + '</span>' : '')
      + '</span>';
  }

  function vrCardHtml(z) {
    var comunas = comunaChips(z.comunas);
    // El estilo sale de z.color, no del texto de z.type: así el rótulo se puede
    // renombrar (ej. "DELIVERY NEXTDAY") sin que la tarjeta cambie de color.
    var typeClass = z.color || 'semanal';
    var emoji = typeClass === 'express' ? '\u{1F69A}' : '\u{1F4E6}';
    // Bloques horarios: solo las zonas con reparto por ventana los declaran.
    var windowsHtml = '';
    if (z.windows) {
      windowsHtml = '<div class="cov-vr-windows">'
        + '<div class="cov-vr-windows__label">\u{1F552} Reparto</div>'
        + '<div class="cov-vr-windows__slots">'
        + windowRow('AM', z.windows.am, z.windows.am_days)
        + windowRow('PM', z.windows.pm, z.windows.pm_days)
        + '</div>'
        + '<p class="cov-vr-windows__note">' + escapeHtml(z.windows.note) + '</p>'
        + '</div>';
    }
    return '<div class="cov-vr-card cov-vr-card--' + typeClass + '" data-zone="' + z.id + '">'
      + '<div class="cov-vr-zone">' + z.type + '</div>'
      + '<div class="cov-vr-header">'
      + '<div class="cov-vr-title">' + emoji + ' ' + z.name + '</div>'
      + '<div class="cov-vr-price">' + z.price + '</div>'
      + '</div>'
      + '<div class="cov-vr-desc">' + z.schedule + '</div>'
      + windowsHtml
      + '<div class="cov-vr-comunas">' + comunas + '</div>'
      + '<a href="#coverage-address-input" class="cov-verify-btn" onclick="(function(e){e.preventDefault();var el=document.getElementById(\'coverage-address-input\');if(el){el.scrollIntoView({behavior:\'smooth\',block:\'center\'});setTimeout(function(){el.focus();},400);}}).call(this,event)">Verifica tu cobertura →</a>'
      + '</div>';
  }

  /* ============================================= */
  /*  MARKER                                       */
  /* ============================================= */

  var markerStyleInjected = false;
  function injectMarkerStyle() {
    if (markerStyleInjected) return;
    markerStyleInjected = true;
    var s = document.createElement('style');
    s.textContent = '@keyframes cov-marker-drop{0%{transform:translateY(-80px);opacity:0}50%{transform:translateY(4px);opacity:1}70%{transform:translateY(-2px)}100%{transform:translateY(0)}}.cov-marker-el{animation:cov-marker-drop 0.45s ease forwards;line-height:0;}';
    document.head.appendChild(s);
  }

  function createMarkerElement() {
    injectMarkerStyle();
    var el = document.createElement('div');
    el.style.lineHeight = '0';
    var inner = document.createElement('div');
    inner.className = 'cov-marker-el';
    inner.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="28" height="38" viewBox="0 0 28 38"><path d="M14 0C6.3 0 0 6.3 0 14c0 10.5 14 24 14 24s14-13.5 14-24C28 6.3 21.7 0 14 0z" fill="#FFC600" stroke="#171717" stroke-width="2"/><circle cx="14" cy="13" r="5" fill="#171717"/></svg>';
    el.appendChild(inner);
    return el;
  }

  /* ============================================= */
  /*  INSTANCE INIT                                */
  /* ============================================= */

  async function initInstance(root) {
    if (root._covInit) return;
    root._covInit = true;

    var mapEl = root.querySelector('[data-cov-map]');
    if (!mapEl) return;

    var geojsonUrl = root.getAttribute('data-geojson-url');
    var geojsonData = null;
    try {
      var resp = await fetch(geojsonUrl);
      geojsonData = await resp.json();
    } catch (err) {
      console.error('Coverage map: failed to load GeoJSON', err);
      return;
    }

    var resultEl = root.querySelector('[data-cov-result]');
    var hintEl = root.querySelector('[data-cov-hint]');
    var emailEl = root.querySelector('[data-cov-email]');
    var inputEl = root.querySelector('[data-cov-input]');
    var clearBtn = root.querySelector('[data-cov-clear]');
    var suggestionsEl = root.querySelector('[data-cov-suggestions]');
    var zonesContainer = root.querySelector('[data-zones-container]');
    var disclaimerEl = root.querySelector('[data-coverage-disclaimer]');
    var calloutEl = root.querySelector('.cov-nextday-callout');

    var searchMarker = null;
    var activeZone = null;
    var currentRegion = 'santiago';

    /* ---- MAPA (MapLibre + OpenFreeMap) ---- */

    var map = new maplibregl.Map({
      container: mapEl,
      style: BASEMAP_STYLE,
      center: [-70.65, -33.45],
      zoom: 10,
      cooperativeGestures: true,
      attributionControl: false
    });
    map.addControl(new maplibregl.NavigationControl({ showCompass: false }), 'top-right');
    map.addControl(new maplibregl.AttributionControl({ compact: true }));

    var ro = new ResizeObserver(function() { map.resize(); });
    ro.observe(mapEl);

    map.on('load', function() {
      map.addSource('coverage-zones', {
        type: 'geojson',
        data: geojsonData
      });

      map.addLayer({
        id: 'zones-fill',
        type: 'fill',
        source: 'coverage-zones',
        paint: {
          'fill-color': fillColorExpr,
          'fill-opacity': 0.3
        }
      });

      map.addLayer({
        id: 'zones-outline',
        type: 'line',
        source: 'coverage-zones',
        paint: {
          'line-color': fillColorExpr,
          'line-width': 2,
          'line-opacity': 0.7
        }
      });

      var regionGeoNames = {};
      COVERAGE_ZONES[currentRegion].zones.forEach(function(z) {
        (z.geoNames || []).forEach(function(n) { regionGeoNames[n] = true; });
      });
      var regionFeatures = geojsonData.features.filter(function(f) {
        return regionGeoNames[f.properties.name];
      });
      if (regionFeatures.length) {
        var bbox = turf.bbox(turf.featureCollection(regionFeatures));
        var isMobile = window.matchMedia('(max-width: 768px)').matches;
        map.fitBounds([[bbox[0], bbox[1]], [bbox[2], bbox[3]]], {
          padding: isMobile ? 20 : 60,
          maxZoom: 12,
          duration: 0
        });
      }

      /* ---- POLYGON CLICK (priority: diario > martes > jueves) ---- */
      var ZONE_PRIORITY = ['Reparto Diario', 'Martes Norte', 'Jueves Sur'];
      map.on('click', 'zones-fill', function(e) {
        if (!e.features || !e.features.length) return;
        var best = null;
        var bestPri = ZONE_PRIORITY.length;
        for (var fi = 0; fi < e.features.length; fi++) {
          var fn = e.features[fi].properties.name;
          var pri = ZONE_PRIORITY.indexOf(fn);
          if (pri !== -1 && pri < bestPri) { best = fn; bestPri = pri; }
        }
        if (!best) best = e.features[0].properties.name;
        var match = GEO_NAME_TO_ZONE[best];
        if (!match) return;
        var zone = match.zone;
        var needsSwitch = match.region !== currentRegion;
        if (needsSwitch) switchRegion(match.region);
        setTimeout(function() {
          highlightCard(zone.id);
          zoomToZone(zone.id);
          highlightZoneOnMap(zone.geoNames);
        }, needsSwitch ? 500 : 0);
      });

      map.on('mouseenter', 'zones-fill', function() {
        map.getCanvas().style.cursor = 'pointer';
      });
      map.on('mouseleave', 'zones-fill', function() {
        map.getCanvas().style.cursor = '';
      });
    });

    /* ---- ADDRESS AUTOCOMPLETE (Geocoding v6 + debounce) ---- */

    var debounceTimer = null;
    var selectedCoords = null;

    if (inputEl) {
      inputEl.addEventListener('input', function() {
        var q = inputEl.value.trim();
        clearBtn.classList.toggle('cov-hidden', !q);
        selectedCoords = null;

        if (debounceTimer) clearTimeout(debounceTimer);
        if (q.length < 3) { suggestionsEl.classList.add('cov-hidden'); return; }

        debounceTimer = setTimeout(async function() {
          try {
            var resultados = await geocode(q, 5);
            if (resultados.length) {
              renderSuggestions(resultados);
            } else {
              suggestionsEl.classList.add('cov-hidden');
            }
          } catch(e) { suggestionsEl.classList.add('cov-hidden'); }
        }, 350);
      });

      inputEl.addEventListener('keydown', function(e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          suggestionsEl.classList.add('cov-hidden');
          root.querySelector('[data-cov-verify]').click();
        }
      });
    }

    function renderSuggestions(items) {
      var html = '';
      items.forEach(function(it, i) {
        html += '<div class="cov-search__suggestion" data-sug-idx="' + i + '">' + escapeHtml(it.label) + '</div>';
      });
      suggestionsEl.innerHTML = html;
      suggestionsEl._features = items;
      suggestionsEl.classList.remove('cov-hidden');
    }

    if (suggestionsEl) {
      suggestionsEl.addEventListener('click', function(e) {
        var item = e.target.closest('[data-sug-idx]');
        if (!item) return;
        var f = suggestionsEl._features[parseInt(item.getAttribute('data-sug-idx'))];
        if (!f) return;
        inputEl.value = f.label;
        selectedCoords = { lat: f.lat, lng: f.lng };
        suggestionsEl.classList.add('cov-hidden');
        clearBtn.classList.remove('cov-hidden');
        handleResult(selectedCoords.lat, selectedCoords.lng);
      });
    }

    if (clearBtn) {
      clearBtn.addEventListener('click', function() {
        inputEl.value = '';
        selectedCoords = null;
        clearBtn.classList.add('cov-hidden');
        suggestionsEl.classList.add('cov-hidden');
        inputEl.focus();
      });
    }

    document.addEventListener('click', function(e) {
      if (!root.querySelector('.cov-search__input-wrap').contains(e.target)) {
        suggestionsEl.classList.add('cov-hidden');
      }
    });

    /* ---- VERIFICAR BUTTON ---- */

    root.querySelector('[data-cov-verify]').addEventListener('click', async function() {
      if (selectedCoords) { handleResult(selectedCoords.lat, selectedCoords.lng); return; }

      var query = inputEl ? inputEl.value.trim() : '';
      if (!query) return;

      resultEl.className = 'cov-search__result cov-search__result--loading visible';
      resultEl.innerHTML = '\u{1F50D} Buscando dirección...';
      if (hintEl) hintEl.style.display = 'none';
      emailEl.classList.remove('visible');

      try {
        var resultados = await geocode(query, 1);
        if (resultados.length) {
          handleResult(resultados[0].lat, resultados[0].lng);
        } else {
          showError('No encontramos esa dirección. Intenta con más detalles (ej: "Av. Providencia 1234, Santiago").');
        }
      } catch (err) {
        showError('Error al buscar la dirección. Intenta de nuevo.');
      }
    });

    /* ---- REGION SWITCHING ---- */

    function switchRegion(regionKey) {
      if (regionKey === currentRegion) return;
      var region = COVERAGE_ZONES[regionKey];
      if (!region) return;

      root.querySelectorAll('[data-region-toggle]').forEach(function(b) {
        b.classList.toggle('active', b.getAttribute('data-region-toggle') === regionKey);
      });

      var regionGeoNames = {};
      region.zones.forEach(function(z) {
        (z.geoNames || []).forEach(function(n) { regionGeoNames[n] = true; });
      });
      var regionFeatures = geojsonData.features.filter(function(f) {
        return regionGeoNames[f.properties.name];
      });
      if (regionFeatures.length) {
        var bbox = turf.bbox(turf.featureCollection(regionFeatures));
        var isMobile = window.matchMedia('(max-width: 768px)').matches;
        map.fitBounds([[bbox[0], bbox[1]], [bbox[2], bbox[3]]], {
          padding: isMobile ? 20 : 60,
          maxZoom: 12,
          duration: 1200
        });
      } else {
        map.flyTo({ center: region.center, zoom: region.zoom, duration: 1200 });
      }

      activeZone = null;
      renderRegionCards(regionKey);
      updateDisclaimer(regionKey);
      currentRegion = regionKey;
    }

    function renderRegionCards(regionKey) {
      if (!zonesContainer) return;
      zonesContainer.style.opacity = '0';

      setTimeout(function() {
        var zones = COVERAGE_ZONES[regionKey].zones;
        var html = '';
        if (regionKey === 'santiago') {
          zones.forEach(function(z) { html += stgoCardHtml(z); });
        } else {
          zones.forEach(function(z) { html += vrCardHtml(z); });
        }
        zonesContainer.innerHTML = html;
        zonesContainer.style.opacity = '1';
      }, 200);
    }

    // El corte de las 18:00 y el despacho gratis son condiciones solo de Santiago.
    // En la Quinta Región no aplican, así que los avisos se ocultan en vez de
    // mostrar una versión ambigua que igual promete un horario de corte.
    function updateDisclaimer(regionKey) {
      var esSantiago = regionKey === 'santiago';
      if (disclaimerEl) {
        disclaimerEl.style.display = esSantiago ? '' : 'none';
        if (esSantiago) {
          disclaimerEl.innerHTML = '✅ Horario de corte de pedidos: hasta las <strong>18:00 hrs</strong>. Despacho gratis sobre $79.990 solo en Santiago.';
        }
      }
      if (calloutEl) calloutEl.style.display = esSantiago ? '' : 'none';
    }

    /* ---- COVERAGE LOGIC ---- */

    function handleResult(lat, lng) {
      var zone = findZone(lat, lng, geojsonData);

      if (searchMarker) searchMarker.remove();
      searchMarker = new maplibregl.Marker({ element: createMarkerElement(), anchor: 'bottom' })
        .setLngLat([lng, lat])
        .addTo(map);

      if (hintEl) hintEl.style.display = 'none';

      if (zone) {
        var needsSwitch = zone.region !== currentRegion;
        if (needsSwitch) switchRegion(zone.region);

        showSuccess(zone);

        var delay = needsSwitch ? 500 : 0;
        setTimeout(function() {
          highlightCard(zone.id);
          map.flyTo({ center: [lng, lat], zoom: 14, duration: 1000 });
        }, delay);
      } else {
        showNoCobertura('tu dirección');
        map.flyTo({ center: [lng, lat], zoom: 14, duration: 1000 });
      }
    }

    function highlightCard(zoneId) {
      root.querySelectorAll('[data-zone]').forEach(function(c) { c.classList.remove('active', 'pulse'); });
      var card = root.querySelector('[data-zone="' + zoneId + '"]');
      if (card) {
        card.classList.add('active');
        void card.offsetWidth;
        card.classList.add('pulse');
        card.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
      activeZone = zoneId;
    }

    function showSuccess(zone) {
      resultEl.className = 'cov-search__result cov-search__result--success visible';
      var badges = '';
      if (zone.badges && zone.badges.length) {
        badges = zone.badges.map(function(b) { return ' <span class="cov-badge-next-day">' + b + '</span>'; }).join('');
      }
      resultEl.innerHTML = '✅ ¡Llegamos a tu dirección! · '
        + '<span class="cov-search__result-badge">' + zone.name + '</span> · '
        + 'Costo: <strong>' + zone.price + '</strong> · '
        + 'Despacho: ' + zone.schedule + badges;
      emailEl.classList.remove('visible');
    }

    function showNoCobertura(comuna) {
      resultEl.className = 'cov-search__result cov-search__result--error visible';
      resultEl.innerHTML = '❌ Por el momento no realizamos envíos a <strong>' + escapeHtml(comuna) + '</strong>. Déjanos tu email y te avisaremos cuando ampliemos cobertura a tu zona.';
      emailEl.classList.add('visible');
      root.querySelector('[data-cov-email-thanks]').style.display = 'none';
      root.querySelector('[data-cov-email-form]').style.display = 'flex';
      root.querySelectorAll('[data-zone]').forEach(function(c) { c.classList.remove('active', 'pulse'); });
      activeZone = null;
    }

    function showError(msg) {
      resultEl.className = 'cov-search__result cov-search__result--error visible';
      resultEl.innerHTML = '⚠️ ' + msg;
      emailEl.classList.remove('visible');
    }

    /* ---- TAB TOGGLE ---- */

    root.querySelectorAll('[data-region-toggle]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        switchRegion(btn.getAttribute('data-region-toggle'));
      });
    });

    /* ---- ZONE HELPERS ---- */

    function findZoneById(zoneId) {
      var zones = COVERAGE_ZONES[currentRegion].zones;
      for (var i = 0; i < zones.length; i++) {
        if (zones[i].id === zoneId) return zones[i];
      }
      return null;
    }

    function zoomToZone(zoneId) {
      var zone = findZoneById(zoneId);
      if (!zone || !zone.geoNames || !zone.geoNames.length) return;
      var matching = geojsonData.features.filter(function(f) {
        return zone.geoNames.indexOf(f.properties.name) !== -1;
      });
      if (!matching.length) return;
      var bbox = turf.bbox(turf.featureCollection(matching));
      map.fitBounds([[bbox[0], bbox[1]], [bbox[2], bbox[3]]], { padding: 50, duration: 1000 });
    }

    function highlightZoneOnMap(geoNames) {
      if (!map.getLayer('zones-fill')) return;
      if (!geoNames || !geoNames.length) {
        map.setPaintProperty('zones-fill', 'fill-opacity', 0.3);
        return;
      }
      var expr = ['match', ['get', 'name']];
      geoNames.forEach(function(n) { expr.push(n, 0.55); });
      expr.push(0.1);
      map.setPaintProperty('zones-fill', 'fill-opacity', expr);
    }

    /* ---- ZONE CARD TOGGLE (event delegation) ---- */

    if (zonesContainer) {
      zonesContainer.addEventListener('click', function(e) {
        var card = e.target.closest('[data-zone]');
        if (!card) return;
        var id = card.getAttribute('data-zone');

        if (activeZone === id) {
          activeZone = null;
          root.querySelectorAll('[data-zone]').forEach(function(c) { c.classList.remove('active'); });
          highlightZoneOnMap(null);
          var region = COVERAGE_ZONES[currentRegion];
          map.flyTo({ center: region.center, zoom: region.zoom, duration: 800 });
          return;
        }

        highlightCard(id);
        zoomToZone(id);
        var zone = findZoneById(id);
        if (zone) highlightZoneOnMap(zone.geoNames);
      });
    }

    /* ---- EMAIL SUBMIT ---- */

    root.querySelector('[data-cov-email-form]').addEventListener('submit', function(e) {
      e.preventDefault();
      if (!root.querySelector('[data-cov-email-input]').value) return;
      root.querySelector('[data-cov-email-form]').style.display = 'none';
      root.querySelector('[data-cov-email-thanks]').style.display = 'block';
    });

    /* ---- INITIAL RENDER ---- */

    renderRegionCards('santiago');
  }

  /* ============================================= */
  /*  INIT ALL INSTANCES                           */
  /* ============================================= */

  async function initAll() {
    var roots = document.querySelectorAll('[data-coverage-map]');
    for (var i = 0; i < roots.length; i++) {
      try {
        await initInstance(roots[i]);
      } catch (err) {
        console.error('Coverage map init error:', err);
      }
    }
  }

  function boot() {
    if (typeof maplibregl === 'undefined' || typeof turf === 'undefined') {
      setTimeout(boot, 150);
      return;
    }
    initAll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
